import { ApiDriverByIdResponse, DriverPreviousLicenceCheckDates } from "../../../../models/api/admin/driver";
import { StatusAction } from "../../../ActionableStatus/ActionableStatus";
import { LicenceChecksActions } from "../licenceCheckActions";
import LicenceCheckStatus from "../LicenceCheckStatus";

type DueForCheckLicenceCheckStatusProps = {
    driverId: string;
    isManual: boolean;
    lastCheckDate: string;
    nextCheckDate: string;
    previousLicenceCheckDates: DriverPreviousLicenceCheckDates;

    buildActions: (actionNames: LicenceChecksActions[]) => StatusAction[];
};

const DueForCheckLicenceCheckStatus = ({
    driverId,
    isManual,
    lastCheckDate,
    nextCheckDate,
    previousLicenceCheckDates,
    buildActions,
}: DueForCheckLicenceCheckStatusProps) => {
    const actions = buildActions(
        isManual
            ? [
                  "editCheckDate",
                  "markAsChecked",
                  "markAsPending",
                  "markAsFailed",
                  "disableFurtherChecks",
                  "changeToAutomatic",
                  "previousLicenceCheckDates",
              ]
            : [
                  "editCheckDate",
                  "retryCheck",
                  "changeToManual",
                  "disableFurtherChecks",
                  "previousLicenceCheckDates",
              ]
    );

    return (
        <LicenceCheckStatus
            previousLicenceCheckDates={previousLicenceCheckDates}
            actions={actions}
            theme="vrm"
            text="Due for check"
            driverId={driverId}
            isManual={isManual}
        >
            <span>Last check: {lastCheckDate}</span>
            <span>Next check: {nextCheckDate}</span>
        </LicenceCheckStatus>
    );
};

export default DueForCheckLicenceCheckStatus;
